exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tip[data-v-65a1f789]{line-height:35px;margin-bottom:10px}.goods_list[data-v-65a1f789]{margin:0 10px;border:1px solid #e6e6e6;border-radius:3px;max-height:250px;overflow:auto}.goods_list>div[data-v-65a1f789]{padding:10px}.goods_list>div+div[data-v-65a1f789]{border-top:1px solid #e6e6e6}.goods_info .info[data-v-65a1f789]{margin-left:10px}.goods_info .info p[data-v-65a1f789]{line-height:20px;color:#666666}.goods_info .info p[data-v-65a1f789]:first-child{color:#999999}\n", ""]);

// exports
